export function boolFromValue(value?: string | boolean): boolean | undefined {
  if (value === undefined) return undefined;
  if (value === true || value === 'True' || value === 'true' || value === '1') return true;
  if (value === false || value === 'False' || value === 'false' || value === '0') return false;
  return undefined;
}

export function numberFromValue(value?: string | number): number | undefined {
  if (value === undefined) return undefined;
  if (value === 0 || value === '0') return 0;
  return Number(value) || undefined;
}

export function stringFromValue(value?: string): string | undefined {
  return value;
}

export function boolToValue(b?: boolean): string | undefined {
  if (b === undefined) return undefined;
  return b ? '1' : '0';
}

export function numberToValue(n?: number): string | undefined {
  if (n === undefined) return undefined;
  return String(n);
}

export function stringToValue(s?: string): string | undefined {
  return s;
}
